import { ReactNode } from "react";
import { FieldValues, UseControllerProps } from "react-hook-form";

import Box from "@mui/material/Box";
import type { SxProps } from "@mui/material/styles";

import SelectFormField from "components/select-form-field";

type WizardSelectFieldProps = {
  label: string;
  icon?: ReactNode;
  required?: boolean;
  options: Array<{ value: string | number; label: string }>;
  sx?: SxProps;
};

type RhfWizardSelectFieldProps<T extends FieldValues> = WizardSelectFieldProps &
  UseControllerProps<T>;

export default function WizardSelectField<T extends FieldValues>({
  control,
  name,
  label,
  icon,
  required,
  options,
  sx
}: RhfWizardSelectFieldProps<T>) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      gap={2}
      sx={sx}
    >
      {Boolean(icon) && icon}
      <SelectFormField
        name={name}
        label={label}
        control={control}
        required={required}
        options={options}
      />
    </Box>
  );
}
